import { Component } from '@angular/core';
import { AdminModule } from '../admin.module';

@Component({
  selector: 'app-quotes-page',
  standalone: true,
  imports: [AdminModule],
  templateUrl: './quotes-page.component.html',
  styleUrl: './quotes-page.component.css'
})
export class QuotesPageComponent {

}
